import { createContext } from 'react';
export var CnFormArrayBaseContext = createContext(null);
export var CnFormArrayBaseItemContext = createContext(null);
